@if (!addCreatorsMode()) {

@if (hasInquiries() && !showAddCreatorPicker()) {


<div class="h-full min-h-0 flex flex-col">
    <div class="flex-1 w-full overflow-hidden">
        <div
            class="h-full min-h-0 flex flex-col divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow card-container-pale-no-padding">

            <div class="flex flex-col gap-y-4 flex-1 min-h-0 overflow-hidden">
                <div class="flex flex-col flex-1 min-h-0 overflow-hidden w-full">
                    <div class="flex-1 min-h-0 overflow-y-auto overflow-x-auto scrollbar-transparent" #scrollContainer
                        infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
                        [infiniteScrollContainer]="scrollContainer"
                        [infiniteScrollDisabled]="!hasMore() || isLoadingMore()" (scrolled)="onScrollDown()">
                        <table class="table-fixed w-full min-w-full divide-y divide-gray-300 dark:divide-gray-700">
                            <thead class="bg-gray-100 dark:bg-gray-900/50 sticky top-0 z-10">
                                <tr>
                                    <th scope="col"
                                        class="py-2 pr-3 pl-2 text-left text-sm font-semibold whitespace-nowrap text-primary">
                                        Creator
                                    </th>
                                    <th scope="col"
                                        class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                                        Instagram
                                    </th>
                                    <th scope="col"
                                        class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                                        TikTok
                                    </th>
                                    <th scope="col"
                                        class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                                        Total Content
                                    </th>
                                    @if (showReviewColumns()) {
                                    <th scope="col"
                                        class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                                        Approved
                                    </th>
                                    <th scope="col"
                                        class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                                        Issues
                                    </th>
                                    <th scope="col"
                                        class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                                        Progress (%)
                                    </th>
                                    }
                                    <th scope="col"
                                        class="px-2 py-3.5 text-right text-sm font-semibold whitespace-nowrap text-primary">
                                        <span class="sr-only">Actions</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
                                @for (inquiry of inquiries(); track inquiry.id) {
                                <tr>
                                    <td class="py-2 pr-3 pl-2 text-sm text-primary">
                                        <div class="flex items-center gap-2 min-w-0">
                                            @if (inquiry.creator.photoURL; as photoSrc) {
                                            <atom-ldg-img class="size-8 shrink-0" inputClass="object-cover" w="full"
                                                h="full" radius="full"
                                                [src]="imageService.getImageSource(photoSrc, 'gallery')"></atom-ldg-img>
                                            } @else {
                                            <div
                                                class="size-8 shrink-0 rounded-full bg-zinc-200 dark:bg-zinc-700 flex items-center justify-center text-[10px] font-semibold text-secondary">
                                                {{ inquiry.creator.firstName.charAt(0) }} {{
                                                inquiry.creator.lastName.charAt(0) }}.
                                            </div>
                                            }
                                            <div class="font-medium text-primary truncate">{{ inquiry.creator.firstName
                                                }}
                                                {{
                                                inquiry.creator.lastName.charAt(0) }}.</div>
                                        </div>
                                    </td>
                                    <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                                        {{ inquiry.creator.instaHandle }} <span class="text-xs text-secondary">({{
                                            formatService.convertIntToString(inquiry.creator.instaFollowers) }})</span>
                                    </td>
                                    <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                                        {{ inquiry.creator.tikTokHandle }} <span class="text-xs text-secondary">({{
                                            formatService.convertIntToString(inquiry.creator.tikTokFollowers) }})</span>
                                    </td>
                                    <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                                        {{ inquiry.publishedContent.length }}
                                    </td>
                                    @if (showReviewColumns()) {
                                    <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                                        0
                                    </td>
                                    <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                                        0
                                    </td>
                                    <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                                        0
                                    </td>
                                    }
                                    <td
                                        class="px-2 py-2 text-sm whitespace-nowrap text-right text-primary flex flex-row items-center justify-end gap-x-2">
                                        <!-- Send to Super Social -->
                                        @if (!sendingToSuperSocial().includes(inquiry.id)) {

                                        @if (inquiry.creator && inquiry.creator.ssCreator &&
                                        inquiry.creator.ssCreator.tiktokAccountId) {
                                        <span
                                            class="inline-flex items-center gap-x-1.5 rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700 dark:bg-green-400/10 dark:text-green-400">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-5 text-green-500 dark:text-green-400">
                                                <path d="M20 6 9 17l-5-5" />
                                            </svg>
                                            TikTok
                                        </span>
                                        } @else if (isPendingSuperSocial(inquiry.id, 'tiktok')) {
                                        <span
                                            [appTooltip]="'Sent to Super Social — awaiting account link'"
                                            position="top"
                                            class="inline-flex items-center gap-x-1.5 rounded-full bg-amber-100 px-2 py-1 text-xs font-medium text-amber-800 dark:bg-amber-400/10 dark:text-amber-300">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-5 text-amber-500 dark:text-amber-400">
                                                <circle cx="12" cy="12" r="10" />
                                                <path d="M12 6v6l4 2" />
                                            </svg>
                                            TT pending
                                        </span>
                                        } @else {
                                        <button type="button" (click)="sendToSuperSocial(inquiry, 'tiktok')"
                                            class="inline-flex gap-x-1.5 items-center primary-button-fuchsia">
                                            Track TT
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="-mr-0.5 size-5">
                                                <path
                                                    d="M17 19a1 1 0 0 1-1-1v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a1 1 0 0 1-1 1z" />
                                                <path d="M17 21v-2" />
                                                <path d="M19 14V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V10" />
                                                <path d="M21 21v-2" />
                                                <path d="M3 5V3" />
                                                <path
                                                    d="M4 10a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2z" />
                                                <path d="M7 5V3" />
                                            </svg>
                                        </button>
                                        }

                                        @if (inquiry.creator && inquiry.creator.ssCreator &&
                                        inquiry.creator.ssCreator.instagramAccountId) {
                                        <span
                                            class="inline-flex items-center gap-x-1.5 rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700 dark:bg-green-400/10 dark:text-green-400">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-5 text-green-500 dark:text-green-400">
                                                <path d="M20 6 9 17l-5-5" />
                                            </svg>
                                            Instagram
                                        </span>
                                        } @else if (isPendingSuperSocial(inquiry.id, 'instagram')) {
                                        <span
                                            [appTooltip]="'Sent to Super Social — awaiting account link'"
                                            position="top"
                                            class="inline-flex items-center gap-x-1.5 rounded-full bg-amber-100 px-2 py-1 text-xs font-medium text-amber-800 dark:bg-amber-400/10 dark:text-amber-300">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-5 text-amber-500 dark:text-amber-400">
                                                <circle cx="12" cy="12" r="10" />
                                                <path d="M12 6v6l4 2" />
                                            </svg>
                                            IG pending
                                        </span>
                                        } @else {
                                        <button type="button" (click)="sendToSuperSocial(inquiry, 'instagram')"
                                            class="inline-flex gap-x-1.5 items-center primary-button-fuchsia">
                                            Track IG
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="-mr-0.5 size-5">
                                                <path
                                                    d="M17 19a1 1 0 0 1-1-1v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a1 1 0 0 1-1 1z" />
                                                <path d="M17 21v-2" />
                                                <path d="M19 14V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V10" />
                                                <path d="M21 21v-2" />
                                                <path d="M3 5V3" />
                                                <path
                                                    d="M4 10a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2z" />
                                                <path d="M7 5V3" />
                                            </svg>
                                        </button>
                                        }
                                        } @else {
                                        <button type="button" [appTooltip]="'Sending...'" position="top"
                                            class="fab-button-subtle">
                                            <svg aria-hidden="true"
                                                class="mx-auto w-4 h-4 text-primary/15 animate-spin dark:text-gray-600 fill-primary"
                                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor" />
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill" />
                                            </svg>
                                        </button>
                                        }
                                        <!-- Send to Super Social - END -->

                                        <button (click)="onInquiryAction(inquiry)" type="button"
                                            [appTooltip]="'Actions'" position="top" class="fab-button-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M5 12h14" />
                                                <path d="m12 5 7 7-7 7" />
                                            </svg>
                                        </button>
                                    </td>
                                </tr>
                                }
                                @if (isLoadingMore()) {
                                <tr>
                                    <td [attr.colspan]="showReviewColumns() ? 8 : 5" class="py-4 text-center text-sm text-secondary">
                                        Loading more...
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


        </div>
    </div>
    <div class="shrink-0 w-full flex flex-row items-center justify-end gap-x-2 pt-2">
        <button type="button" (click)="openAddCreatorPicker()"
            class="primary-button inline-flex flex-row items-center gap-x-2">
            Add Creators
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" x2="19" y1="8" y2="14" />
                <line x1="22" x2="16" y1="11" y2="11" />
            </svg>
        </button>
    </div>
</div>


} @else {
<div class="h-full flex-1 flex flex-col gap-y-4 items-center justify-center w-full overflow-hidden">

    <!-- @if (showAddCreatorPicker() && hasInquiries()) { -->
    @if (showAddCreatorPicker() && !hasInquiries()) {
    <div class="w-full max-w-2xl flex flex-row items-center justify-start">
        <button (click)="closeAddCreatorPicker()" type="button" class="fab-button-secondary"
            aria-label="Back to creators list">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
            </svg>
        </button>
    </div>
    }

    @if (!hasInquiries()) {
    <div class="max-w-2xl text-center">
        <div
            class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-lime-100 dark:bg-lime-900/30 mb-6">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-10 text-lime-600 dark:text-lime-400">
                <path d="M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97" />
                <path
                    d="M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z" />
                <path d="M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15" />
                <path d="M2 21v-4" />
                <path d="M7 9h.01" />
            </svg>
        </div>
        <h2 class="text-2xl font-semibold text-primary mb-4">No Creators Yet</h2>
        <p class="text-base text-secondary leading-relaxed mb-6 mx-8">
            Please add creators to the monitoring brief to get started.
        </p>
    </div>
    }

    <div>
        <h2 class="text-base/7 font-semibold text-primary">How would you like to add creators?</h2>
        <p class="text-sm/6 text-secondary">Choose one of the options to below to add creators.
        </p>

        <ul role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6">
            @for (item of addCreatorOptions; track $index) {
            <li class="col-span-1 flex rounded-md border-zinc-500 cursor-pointer hover:scale-105 transition-all duration-300"
                (click)="selectCreatorOption(item)">
                <div class="flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium cursor-pointer"
                    [class]="item.class">
                    @switch (item.id) {
                    @case (1) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <circle cx="10" cy="7" r="4" />
                        <path d="M10.3 15H7a4 4 0 0 0-4 4v2" />
                        <circle cx="17" cy="17" r="3" />
                        <path d="m21 21-1.9-1.9" />
                    </svg>
                    }
                    @case (2) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <rect width="13" height="7" x="8" y="3" rx="1" />
                        <path d="m2 9 3 3-3 3" />
                        <rect width="13" height="7" x="8" y="14" rx="1" />
                    </svg>
                    }
                    @case (3) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <path d="M12 3v12" />
                        <path d="m17 8-5-5-5 5" />
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    </svg>
                    }
                    @case (4) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <path d="M16 5H3" />
                        <path d="M16 12H3" />
                        <path d="M11 19H3" />
                        <path d="m15 18 2 2 4-4" />
                    </svg>
                    }
                    }
                </div>

                <div
                    class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10 cursor-pointer">
                    <div class="flex-1 truncate px-4 py-2 text-sm">
                        <a class="font-medium text-primary hover:text-gray-200">{{ item.name
                            }}</a>
                        <p class="text-secondary truncate">{{ item.description }}</p>
                    </div>
                </div>
            </li>
            }
        </ul>

        @if (showAddCreatorPicker() && hasInquiries()) {
        <div class="w-full flex flex-row items-center justify-start gap-x-2 mt-2">
            <!-- <button type="button" (click)="closeAddCreatorPicker()" class="fab-button-secondary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                    </svg>
                </button> -->

            <button (click)="closeAddCreatorPicker()" type="button"
                class="secondary-button text-primary inline-flex flex-row items-center gap-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
                Cancel</button>
        </div>
        }
    </div>




</div>
}
} @else {
<div
    class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4 border-t border-gray-200 dark:border-gray-700 pt-2 ">
    <div class="flex-0 flex flex-row items-center justify-between w-full">
        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="addCreatorsMode.set(false)" type="button" class="fab-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                </svg>
            </button>

            <div class="">
                <div class="inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary">Add Creators
                    </h3>
                </div>
                <p class="mt-0 text-xs text-secondary">Which creators are you monitoring?</p>
            </div>
        </div>

        <div class="flex flex-row items-center justify-end gap-x-4">
            <div class="">
                <nav aria-label="Tabs" class="flex space-x-2">
                    <a (click)="creatorModeTab.set(1)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(1)">Search Creators</a>
                    <!-- <a (click)="creatorModeTab.set(2)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(2)">Add Manually</a> -->
                    <a (click)="creatorModeTab.set(3)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(3)">Upload CSV</a>
                    <!-- <a (click)="creatorModeTab.set(4)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(4)">Existing List</a> -->
                </nav>

            </div>
        </div>

    </div>
    <!-- Main Tabbed Section -->
    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
        @switch (creatorModeTab()) {
        @case (1) {
        <mc-search-creators class="w-full h-full" [monitoringMode]="true"></mc-search-creators>
        }
        @case (2) {
        <mc-add-manually></mc-add-manually>
        }
        @case (3) {
        <mc-upload-csv class="w-full h-full" [focussedMonitoringBriefId]="focussedMonitoringBriefId"
            (close)="addCreatorsMode.set(false)" (listUploaded)="listUploaded($event)"></mc-upload-csv>
        }
        @case (4) {
        <rg-group-picker class="h-full w-full" [mode]="'attach-to-brief'"
            [briefContext]="{ kind: 'monitoring', briefId: focussedMonitoringBriefId }"
            (attached)="creatorListSet(true)"></rg-group-picker>
        }
        }
    </div>
</div>
}